import React, { useState } from "react";
import "./Products.css";

export default function ProductArComponent({
  ProductName,
  NameFSize,
  NameFSizeMob,
  NameTop,
  NameTopMob,
  NameLeft,
  NameLeftMob,
  ImgSrc,
  ImgAlt,
  ProductWeight,
  NutritionItems,
  NutritionName,
  orderWeb,
  orderMobile,
}) {
  const isMobile = window.innerWidth <= 768;

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  if (isMobile) {
    return (
      <>
        <div className={`ProductMob ${isExpanded ? "expanded" : ""}`} onClick={toggleExpand}>
          <div className="ProductMobTop">
            <div
              className={`PCMobAbove ar TGLo24PxPC ${isExpanded ? "visible" : "hidden"}`}
              style={{
                fontSize: isMobile ? NameFSizeMob : NameFSize,
                top: isMobile ? NameTopMob : NameTop,
                left: isMobile ? NameLeftMob : NameLeft,
              }}
            >
              {ProductName}
            </div>
            <div className="BoxMobContainer">
              <img src={ImgSrc} alt={ImgAlt} className={`ProductMobImgSrc ${isExpanded ? "small-image" : ""}`} />
            </div>
            <div className={`PCMobDown ar TFut20PxPC ${isExpanded ? "visible" : "hidden"}`}>{ProductWeight}</div>
          </div>

          <div className={`ProductMobData ar ${isExpanded ? "visible" : "hidden"}`}>
            <div className="PCMDNN">
              <div className="ProductMobDataNN ar TFut20PxPC">{NutritionName}</div>
            </div>
            <div className="PCMDNI">
              {NutritionItems.map((item, index) => (
                <div className="PCMDII ar" key={index}>
                  <div className="PC_ETS_L_F ar TF16PxSC">{item.ItemName}</div>
                  <div className="PC_ETS_L_S ar TFut16PxPCUC">{item.ItemDes}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="PCMain">
        <div className="PC_Closed">
          <div className="PC_Open_L">
            <div className="PC_Text_Above ar TGLo24PxPC" style={{ fontSize: NameFSize, top: NameTop, left: NameLeft }}>
              {(() => {
                const words = ProductName.split(" ");
                if (words.length > 2) {
                  return (
                    <>
                      {words.slice(0, 2).join(" ")}
                      <br />
                      {words.slice(2).join(" ")}
                    </>
                  );
                } else {
                  return ProductName;
                }
              })()}
            </div>
            <div className="ImgContainer">
              <img src={ImgSrc} alt={ImgAlt} />
            </div>
            <div className="PC_Text_Down ar TFut20PxPC" dir="rtl">
              {ProductWeight}
            </div>
          </div>
          <div className="PC_Expanded_Text ar">
            <div className="PC_Epanded_T_F ar TFut20PxPC" dir="rtl">
              {NutritionName}
            </div>
            {/*  */}
            <div className="PC_Epanded_T_S">
              {NutritionItems.map((item, index) => (
                <div className="PC_ETS_L ar" key={index}>
                  <div className="PC_ETS_L_F ar TF16PxSC">{item.ItemName}</div>
                  <div className="PC_ETS_L_S ar TFut16PxPCUC" dir="rtl">
                    {item.ItemDes}
                  </div>
                </div>
              ))}
            </div>
            {/*  */}
          </div>
        </div>
      </div>
    </>
  );
}
